import { useMutation } from 'react-query';
import PESService from 'App/services/PESService';
import { queryClient } from 'Shared/queryClient';

function useAddGeneratedMobileLinkMutation(patientId, activityId) {
    return useMutation(
        () => {
            return PESService.addGeneratedMobileLink(patientId, activityId);
        },
        {
            onSuccess: () => {
                // Invalidate queries for activities fetched in patient activities component
                queryClient.invalidateQueries(['patient', patientId, 'activities']);
            },
        }
    );
}

export default useAddGeneratedMobileLinkMutation;
